import { Container, Grid, Stack, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import SmartphoneOutlined from '@mui/icons-material/SmartphoneOutlined';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined';
import ConfirmationNumberOutlined from '@mui/icons-material/ConfirmationNumberOutlined';
import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined';
import LocalActivityOutlined from '@mui/icons-material/LocalActivityOutlined';
import { useFetch } from '../../hooks/useFecth';
import MetricCard from './components/MetricCard';

function formatCount(value) {
    return (Number(value) || 0).toLocaleString('pt-BR');
}

const CARDS = [
    {
        key: 'assinantesAtivos',
        title: 'Assinantes ativos',
        icon: <GroupIcon />,
        to: '/dashboard/assinantes?subscriptionStatus=ACTIVE',
    },
    {
        key: 'clubesAtivos',
        title: 'Clubes ativos',
        icon: <BusinessIcon />,
        to: '/dashboard/clubes?status=true',
    },
    {
        key: 'clubesComApp',
        title: 'Clubes com aplicativo',
        icon: <SmartphoneOutlined />,
        to: '/dashboard/clubes?customs=custom_app',
    },
    {
        key: 'anunciantesAtivos',
        title: 'Anunciantes ativos',
        icon: <StorefrontOutlined />,
        to: '/dashboard/anunciantes?status=true',
    },
    {
        key: 'ofertasAtivas',
        title: 'Ofertas ativas',
        icon: <LocalOfferIcon />,
        to: '/dashboard/ofertas?status=true',
    },
    {
        key: 'beneficiosAtivos',
        title: 'Benefícios ativos',
        icon: <CardGiftcardOutlined />,
        to: '/dashboard/beneficios',
    },
    {
        key: 'cuponsResgatados',
        title: 'Cupons resgatados',
        icon: <ConfirmationNumberOutlined />,
        to: '/dashboard/resgates',
    },
    {
        key: 'cashbackResgatados',
        title: 'Cashback resgatados',
        icon: <AccountBalanceWalletOutlined />,
        to: '/dashboard/cashback',
    },
    {
        key: 'vouchersResgatados',
        title: 'Vouchers resgatados',
        icon: <LocalActivityOutlined />,
        to: '/dashboard/resgates',
    },
];

export default function Dashboard() {
    const { data: stats } = useFetch('dashboard/stats');

    return (
        <Box>
            <Container maxWidth="xl">
                <Stack pb={3}>
                    <Typography variant="h2" gutterBottom>
                        Dashboard
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Totais ativos da operação
                    </Typography>
                </Stack>

                <Grid container spacing={3}>
                    {CARDS.map(card => (
                        <Grid item xs={12} sm={6} md={4} key={card.key}>
                            <Box
                                component={Link}
                                to={card.to}
                                sx={{
                                    display: 'block',
                                    height: '100%',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                }}
                            >
                                <MetricCard title={card.title} value={formatCount(stats?.[card.key])} icon={card.icon} />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
